import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'web-ui-components/lib/atoms/forms';
import { ValidationMessage } from 'web-ui-components/lib/molecules/forms';
import styles from '../BacsPaymentStyles';
import withValidation from '../../../../containers/withValidation';

export function buildSelectOption(label, value) {
	return { label, value };
}

export function getBacsIdsToSelectOptions(ids = []) {
	return [buildSelectOption('Please select', ''), ...ids.map((id) => buildSelectOption(id, id))];
}

function BacsId({ bacsIdOptions, bacsId, onChange, isValid, showValidation, invalidMessage }) {
	const showErrorMessage = !isValid && showValidation;
	return (
		<div>
			{bacsIdOptions.length > 1 ? (
				<Select
					id="BacsId"
					value={bacsId}
					options={getBacsIdsToSelectOptions(bacsIdOptions)}
					iconType="ChevronDownSolidSmall"
					onChange={(e) => onChange(e.target.value)}
				/>
			) : (
				<div className={styles.static__field} data-test-id="bacs-id-form-field">
					{bacsId}
				</div>
			)}
			{showErrorMessage && (
				<div className={styles.main__validation}>
					<ValidationMessage hasIcon={false} value={invalidMessage} />
				</div>
			)}
		</div>
	);
}

BacsId.propTypes = {
	bacsId: PropTypes.string,
	bacsIdOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
	onChange: PropTypes.func.isRequired,
	isValid: PropTypes.bool,
	showValidation: PropTypes.bool,
	invalidMessage: PropTypes.string.isRequired,
};

export { BacsId };
export default withValidation({ validations: ['required'], key: 'bacsId' })(BacsId);
